<template>
  <div class="page">
    <div class="card-content">
      <div
        class="card-wrapper"
        @click="
          $router.push({
            path: '/quotation/list',
            query: {
              pid: pid,
            },
          })
        "
      >
        <div>报价单</div>
        <img :src="'https://picsum.photos/seed/1/260/130'" />
      </div>
      <div
        class="card-wrapper"
        @click="
          $router.push({
            path: '/demand/list',
            query: {
              pid: pid,
            },
          })
        "
      >
        <div>需求变更表</div>
        <img :src="'https://picsum.photos/seed/3/260/130'" />
      </div>
      <div
        class="card-wrapper"
        @click="
          $router.push({
            path: '/bug/list',
            query: {
              pid: pid,
            },
          })
        "
      >
        <div>缺陷反馈表</div>
        <img :src="'https://picsum.photos/seed/4/260/130'" />
      </div>
      <div
        class="card-wrapper"
        @click="$message.warn('开发中')"
      >
      <!--
          $router.push({
            path: '/contract/list',
            query: {
              pid: pid,
            },
          })
      -->
        <div>合同</div>
        <img :src="'https://picsum.photos/seed/2/260/130'" />
      </div>
      <div
        class="card-wrapper"
        @click="$message.warn('开发中')"
      >
        <!--
          $router.push({
            path: '/returned/list',
            query: {
              pid: pid,
            },
          })
        -->
        <div>回款单</div>
        <img :src="'https://picsum.photos/seed/9/260/130'" />
      </div>
      <div
        class="card-wrapper"
        @click="$message.warn('开发中')"
      >
        <!--
          $message.warn('开发中')
          $router.push({
            path: '/check/list',
            query: {
              pid: pid,
            },
          })
        -->
        <div>签收单</div>
        <img :src="'https://picsum.photos/seed/10/260/130'" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
    };
  },
  // 初始化数据
  async mounted() {
    this.pid = this.$route.query.id
  },
  methods: {
  },
};
</script>
<style scoped lang="scss">
.operation {
  display: flex;
  justify-content: space-between;
}
.card-content {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  .card-wrapper {
    margin-bottom: 45px;
    width: 25%;
    text-align: center;
    position: relative;
  }
  .card-wrapper img {
    width: 80%;
    opacity: 0.8;
  }
  .card-wrapper div {
    cursor: pointer;
    position: absolute;
    top: 30%;
    text-align: center;
    color: #fff;
    font-size: 32px;
    width: 100%;
    z-index: 100;
  }

  .card-item {
    display: inline-block;
    width: 300px;
    margin: 0 0 20px;
    .card-box {
      display: flex;
      flex-direction: column;
      img {
        width: 100%;
      }
      .name {
        text-align: left;
        font-size: 18px;
        padding-top: 10px;
        margin-bottom: -10px;
      }
    }
  }
}
</style>
